import {
  Text,
  Icon,
  IconStatus,
  TableBody,
  TableItem,
  IconTypes,
  HStack,
  VStack,
} from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { columnWidthsDesktop } from '../../constants';
import { ActionButton } from '../ActionButton';

import { RestrictedCustomersListItemTypes } from '.';

export const RestrictedCustomersListItemDesktop: React.FC<
  RestrictedCustomersListItemTypes.Content
> = ({
  rotation,
  item,
  actionIconColor,
  actionPressable,
  actionTextColor,
  isSendDisabled,
  blockListRetryLoading,
}) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const getStatusIcon = () => {
    if (item.statusIcon && item.statusColor && item.statusSize) {
      return (
        <IconStatus
          icon={item.statusIcon as IconTypes.Props['name']}
          color={item.statusColor as ColorTypes.Option}
          testId={`${item.statusIcon}-status-icon`}
          size={item.statusSize as IconTypes.Props['size']}
          bgColor={item.statusBackground as ColorTypes.Option}
        />
      );
    }
  };

  const [isComponentHovered, setIsComponentHovered] = useState(false);

  const currentStatus = getStatusIcon();

  return (
    <TableBody testId="table-body" spaceX="inset.sm">
      <TableItem align="start" width={columnWidthsDesktop.info} testId="header-id">
        <VStack justifyContent={'center'} alignItems={'center'}>
          <Pressable
            marginRight={Spacing['inset.nano']}
            backgroundColor="transparent"
            onPress={() =>
              navigate('BlockDetails', { customerId: item.requestedUser!, channel: item.channel! })
            }
            onHoverIn={() => setIsComponentHovered(true)}
            onHoverOut={() => setIsComponentHovered(false)}>
            <Icon
              name="Info"
              color={Color['brand.tertiary.principal']}
              size="xs"
              testId="status-icon"
              backgroundColor="transparent"
            />
            <Box
              shadow={1}
              flex={1}
              position="absolute"
              top="100%"
              left={0}
              width="300px"
              bg="white"
              borderColor="gray.200"
              borderRadius="md"
              p={2}
              display={isComponentHovered ? 'flex' : 'none'}
              zIndex={1}>
              <Text backgroundColor={Color['neutral.light']}>
                Consulte os detalhes adicionais deste histórico.
              </Text>
            </Box>
          </Pressable>
        </VStack>
      </TableItem>

      <TableItem align="start" width={columnWidthsDesktop.name} testId="header-order">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.semibold']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.requestedUserName}
          </Text>
        </VStack>
      </TableItem>

      <TableItem align="start" width={columnWidthsDesktop.requester} testId="header-last-update">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.requestedUserType}
          </Text>
        </VStack>
      </TableItem>
      <TableItem align="start" width={columnWidthsDesktop.channel} testId="header-clients">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.channel}
          </Text>
        </VStack>
      </TableItem>

      <TableItem align="start" width={columnWidthsDesktop.blockingDate} testId="header-assets">
        <VStack justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            alignItems={'center'}
            paddingLeft={Spacing['inline.nano']}
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.requestedAtFormatted}
          </Text>
        </VStack>
      </TableItem>

      <TableItem align="start" width={columnWidthsDesktop.status} testId="header-clients">
        <HStack flex={1} maxWidth="108%" justifyContent={'center'} alignItems={'center'}>
          {currentStatus}
          <Text
            pl={Spacing['inline.nano']}
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.statusNameAlias}
          </Text>
        </HStack>
      </TableItem>

      <TableItem align="start" width={columnWidthsDesktop.confirm} testId="header-actions">
        <ActionButton
          rotation={rotation}
          blockListRetryLoading={blockListRetryLoading}
          isSendDisabled={isSendDisabled}
          canRetry={item.canRetry}
          actionPressable={actionPressable}
          actionIconColor={actionIconColor}
          actionTextColor={actionTextColor}
        />
      </TableItem>
    </TableBody>
  );
};
